import ReactQueryProvider from "./react-quey.provider";

export default function Providers({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return <ReactQueryProvider>{children}</ReactQueryProvider>;
}
